/* @flow */

import { Formik, Form, Field } from 'formik';
import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';
import * as Yup from 'yup';

import styles from 'src/shared/app/authentication/component/base/AuthenticationBase.style';
import messages from 'src/shared/app/signup/l10n/emailSignupL10n';
import { signupEmailFieldMaxLength } from 'src/shared/app/signup/settings/signupSettings';
import AuthenticationFormHeader from 'src/shared/app/authentication/component/base/AuthenticationFormHeader';
import FormikFormGroup from 'src/shared/app/base/component/data-entry/form/FormikFormGroup';
import SecondaryButton from 'src/shared/ui/component/button/SecondaryButton';

type Props = {
  email: ?string,
  handleSubmit: (Object) => Promise<any>,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const SignupEmailFormDumb = ({
  email,
  handleSubmit,
  intl,
}: Props): React.Node => {
  const schema = Yup.object().shape({
    email: Yup.string().required().email(),
  });

  /*
   |------------------------------------------------------------------------------
   | Classes
   |------------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |------------------------------------------------------------------------------
   | Elements
   |------------------------------------------------------------------------------
   */

  return (
    <Formik
      initialValues={{ email: email || '' }}
      validationSchema={schema}
      validateOnBlur={true}
      onSubmit={(values, { setSubmitting, setStatus }) =>
        handleSubmit(values).catch(({ errors }) => {
          setSubmitting(false);

          const { root, email, username } = errors || {};

          if (root || email || username) {
            setStatus(root || email || username);
          }
        })
      }
    >
      {({ status, dirty, isSubmitting }) => (
        <Form className={classes.form} noValidate>
          <AuthenticationFormHeader withError={!!status}>
            {status || intl.formatMessage(messages.legend)}
          </AuthenticationFormHeader>
          <Field
            id="email"
            name="email"
            type="email"
            component={FormikFormGroup}
            componentOpts={{ label: intl.formatMessage(messages.label) }}
            maxLength={signupEmailFieldMaxLength}
            required
            autoFocus
          />
          <div className={classes.submit}>
            <SecondaryButton isDisabled={!dirty} isSubmitting={isSubmitting}>
              {intl.formatMessage(messages.submit)}
            </SecondaryButton>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default compose(React.memo, injectIntl)(SignupEmailFormDumb);
